<template>
    <div id="commission-wrapper"
         v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <div class="row text-center">
            <div class="col text-white pt-5">
                <h1 class="lato-extra-bold title">Earn Commisions</h1>
            </div>
        </div>
        <div class="row text-center pt-2">
            <div class="col-sm-10 col-10 offset-sm-1 offset-1 text-white">
                <p class="lato-normal text-center d-none d-lg-block">
                  Bitcoin.com Games Affiliates offers one of the most competitive commission plans on the<br />market - with no negative carryover! Register today and start earning!
                </p>
                <p class="lato-normal text-center d-block d-lg-none">
                  BitcoinGames as one of the best commisions<br />- with no carryover! Register today to start earning!
                </p>
            </div>
        </div>
        <div class="row text-center justify-content-center mt-5 card-wrapper">
          <span v-for="(commission, idx) in commissions" v-bind:key="commission.percentage" class="commission-card text-white">
            <p v-for="coinIdx in commission.bitcoin"
               v-bind:key="coinIdx"
               :style="{ position: 'absolute', height: '1vw'}"
               class="commission-card-coins">
              <img :class="'coin-circle ' + (idx === 0 ? ' left-half' : 'coin-full')" :style="{'z-index': 100 + coinIdx, left: getLeftForCoinCircle(coinIdx, commission.bitcoin)}">
            </p>
            <p class="commission-card-amount ml-2 ml-sm-3 mt-4">{{ commission.amount }} BTC</p>
            <p class="commission-card-percentage ml-2 ml-sm-3">{{ commission.percentage }}</p>
          </span>
          <img class="commission-image w-100">
          <div class="w-100 register-button-wrapper">
            <button v-on:click="register()" type="button" class="register-button lato-extra-bold">Register Now</button>
          </div>
        </div>
    </div>
</template>

<script>
    import {doScroll} from '../assets/js/scroll';
    import {registrationLink} from '../assets/js/registration';
    import {mapActions, mapGetters} from "vuex";
    export default {
        name: "Commission",
        computed: {
          ...mapGetters([
            'intersectionOptions'
          ]),
          orientation: () => window.innerWidth > window.innerHeight ? "landscape" : "portrait"
        },
        data() {
          return {
            isMobile: /iPhone|Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent),
            isIPad: /iPad|iPod/i.test(navigator.userAgent),
            commissions: [
              { amount: '0.5', bitcoin: 1, percentage: '25%' },
              { amount: '0.5 - 1', bitcoin: 1, percentage: '30%' },
              { amount: '1 - 2', bitcoin: 2, percentage: '40%' },
              { amount: '2 - 3', bitcoin: 3, percentage: '45%' },
              { amount: '3 - 5', bitcoin: 5, percentage: '50%' },
              { amount: '5 - 10', bitcoin: 10, percentage: '60%' }
            ]
          }
        },
        methods: {
            ...mapActions([
                'setActiveTab',
            ]),
            onWaypoint({ going}) {
                if(going === 'in') {
                    this.setActiveTab('commission-wrapper');
                }
            },
            register() {
              this.setActiveTab('');
              this.registrationLink();
            },
            registrationLink,
            doScroll,
            getLeftForCoinCircle(coinIdx, coinCount) {
              // squeeze 'em if there's ten
              let factor = coinCount === 10 ? (this.isMobile ? 0.75 : 0.85) : 0.7
              return this.isMobile ? ((coinIdx * 2.5 * factor) + 'vmin') : (this.isIPad ? (coinIdx * factor + 'vw') : (coinIdx * factor) + 'vw')
            }
        }
    }
</script>

<style scoped>

    .commission-card {
      height: 213px;
      margin-left: 9px;
      margin-right: 9px;
      display:inline;
      background: linear-gradient(326.28deg, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0.33) 100%);
      -webkit-backdrop-filter: blur( 44px );
      backdrop-filter: blur(44px);
      /* Note: backdrop-filter has minimal browser support */
      border-radius: 8px;
      border: 1px solid;
      border-image-source: linear-gradient(151.82deg, #FFFFFF -9.35%, rgba(255, 255, 255, 0) 49.78%, rgba(255, 255, 255, 0.28) 93.33%);
      font-family: "Gilroy", sans-serif;
      font-weight: 600;
      z-index: 100;
    }

    .card-wrapper {
      position: relative;
    }

    .commission-image {
      content: url("~@/assets/commission-panel-bottom.svg");
      position:absolute;
      bottom:0;
    }

    .commission-card-coins {
      margin-top: -16px;
    }

    .coin-circle {
      position:absolute;
      width: 2vw;
    }

    .coin-full {
      content: url("~@/assets/bitcoin-sign.svg");
    }

    .left-half {
      content: url("~@/assets/bitcoin-sign-left-half.svg");
    }

    .commission-card-amount {
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0;
    }

    .commission-card-percentage {
      font-family: "Gilroy-Bold", sans-serif;
    }

    .register-button {
      width: 184px;
      height: 48px;
      background: #FFFFFF;
      border-radius: 8px;
      position: absolute;
      bottom: 6vw;
      left: calc(50% - 92px);
    }

    /*For Desktop/Laptop Display*/
    @media (min-width: 576px) {
        #commission-wrapper {
          background-size: 100%;
          background-color: #004750;
          position: relative;
        }

        .commission-card {
          width: 11%;
          flex: 0 0 11%;
          max-width: 11%;
          margin-bottom: 14vw;
        }

        p {
          text-align: justify;
          font-size: calc(0.3rem + 2vmin);
        }

        h1 {
          font-size: calc(2.5rem + 5vmin);
        }

        .title {
          font-size: 44px;
          line-height: 53px;
        }
    }

    @media (max-width: 1024px) {
      .commission-card {
        height: 175px;
      }
      .commission-card-percentage {
        font-size: 4vw;
      }
      .commission-card-amount {
        font-size: 1.5vw;
      }
    }

    @media (min-width: 1024px) {
      .commission-card-percentage {
        font-size: 4.5vw;
        line-height: 68px;
      }
    }

    /* IPad */
    @media (min-width: 576px)
      and (max-width: 1024px) {
      .coin-circle {
        width: 2vmin;
      }

      .commission-card-coins {
        margin-top: -1vmin;
      }
    }

    /*For Mobile Display*/
    @media (max-width: 576px) {
        #commission-wrapper {
          background-image: url('~@/assets/home.png');

          /* The image used */
          height: 100%;
          background-attachment: fixed;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          background-color: #004750;
        }

        .commission-card {
          width: 25%;
          flex: 0 0 25%;
          max-width: 25%;
          margin-bottom: 20px;
          margin-left: 1vw;
          margin-right: 1vw;
        }

        .commission-card-percentage {
          font-size: 1.9em;
        }

        .commission-card-amount {
          font-size: 0.85em;
        }

        .commission-image {
          right: 0
        }

        .register-button-wrapper {
          height: 100px;
        }

        .register-button {
          bottom: 11vw;
        }

        /* 5vmin on mobile will represent 32px of the original image for desktop, for calculations */
        .coin-circle {
          width: 5vmin;
        }

        .commission-card-coins {
          margin-top: -2.5vmin;
        }

        h1 {
            font-size: calc(1rem + 5vmin);
        }

        p {
            text-align: justify;
            font-size: calc(0.6rem + 1.2vmin);
        }
    }
</style>
